/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import TableGrid from '../../../../SharedModules/Table/tableGrid';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RenderEditableBankruptcy from './gridComponents/RenderEditableBankruptcy';
import RenderEditableSelect from './gridComponents/RenderEditableSelect';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';

import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';
import { validDate } from '../../../../SharedModules/CommonUtilities/commonUtilities';

import {
  deleteBankruptcyData,
  addNewRowBankruptcy,
} from '../store/ManufacturerAction';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { MinDate } from '../../../../SharedModules/CommonConstants/commonConstants';

export default function ManufacturerBankruptcy(props) {
  const { isEnablebyRole } = props;
  const frameworkComponents = {
    SelectionBoxRender: (cellInfo) => {
      return (
        <RenderEditableSelect
          {...cellInfo}
          commonDropdownList={props.commonDropdownList}
          isEnablebyRole={isEnablebyRole}
        />
      );
    },
    CheckBox: (cellInfo) => {
      const bankruptcyList = useSelector((state) => {
        return state.sharedState.ManufacturerReducer.bankruptcyList;
      });
      return (
        <>
          <div className='tbl-checkbox frr-display-hidden-checkbox-label'>
            <FormControlLabel
              id={`banckruptcy${cellInfo?.rowIndex}`}
              data-testid='checkBox'
              label='Claim Pirior Checkbox'
              control={<Checkbox color='primary' />}
              onClick={(e) => {
                const newObj = [];
                cellInfo.api.forEachNode((node) => newObj.push(node.data));
                const rowIndex =
                  newObj?.length > 0 &&
                  newObj?.findIndex((x) => {
                    return x.id?.toString() === cellInfo?.data?.id?.toString();
                  });
                newObj[rowIndex].addEditRow = true;
                newObj[rowIndex].inclInvoiceInd = e?.target?.checked;
                dispatch(addNewRowBankruptcy(newObj, 'verify'));
                props.setDisabledSaveCancelBtn(false);
                cellInfo.node.setDataValue(
                  'inclInvoiceInd',
                  e?.target?.checked
                );
                cellInfo.api.refreshCells();
              }}
              onKeyDown={(e) => {
                if (
                  ((e.key === 'Tab' && !e.shiftKey) ||
                    e.key === 'ArrowRight') &&
                  bankruptcyList.length === cellInfo.rowIndex + 1
                ) {
                  props.addBankruptcyRow();
                }
              }}
              checked={cellInfo?.data?.inclInvoiceInd}
              value={cellInfo?.data?.inclInvoiceInd}
              disabled={!isEnablebyRole}
            />
          </div>
        </>
      );
    },
    DeleteBoxRender: (cellInfo) => {
      return (
        <div className='tdCell icon-btn-group'>
          {showComments ? (
            <Button
              onClick={() => {
                if (cellInfo.data.corrLinkId) {
                  setCorrLinkId(cellInfo.data.corrLinkId);
                  setShowComments(true);
                }
              }}
              tabIndex={'0'}
              onKeyDown={(e) => {
                // Handle Enter and Space key events
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // Prevents the default space scrolling behavior
                  if (cellInfo.data.corrLinkId) {
                    setCorrLinkId(cellInfo.data.corrLinkId);
                    setShowComments(true);
                  }
                }
              }}
              aria-label='Comment'
              className={`th-ic comment-ic ${
                parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                  ? 'frr-enabled-comment-btn'
                  : 'frr-disabled-comment-btn'
              }`}
              variant='text'
            >
              {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                <img alt='' src={CommentVisibleIcon} />
              ) : (
                <img alt='' src={CommentIcon} />
              )}
            </Button>
          ) : (
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
            >
              <Button
                onClick={() => {
                  if (cellInfo.data.corrLinkId) {
                    setCorrLinkId(cellInfo.data.corrLinkId);
                    setShowComments(true);
                  }
                }}
                tabIndex={'0'}
                onKeyDown={(e) => {
                  // Handle Enter and Space key events
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault(); // Prevents the default space scrolling behavior
                    if (cellInfo.data.corrLinkId) {
                      setCorrLinkId(cellInfo.data.corrLinkId);
                      setShowComments(true);
                    }
                  }
                }}
                disabled={cellInfo.data.corrLinkId === null || !isEnablebyRole}
                aria-label='Comment'
                className={`th-ic comment-ic ${
                  parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                    ? 'frr-enabled-comment-btn'
                    : 'frr-disabled-comment-btn'
                }`}
                variant='text'
              >
                {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                  <img alt='' src={CommentVisibleIcon} />
                ) : (
                  <img alt='' src={CommentIcon} />
                )}
              </Button>
            </OverlayTrigger>
          )}
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}
          >
            <Button
              data-testid='deleteBtn'
              aria-label='Delete'
              className='th-ic trash-blue'
              variant='text'
              disabled={cellInfo.data.permanentDelete || !isEnablebyRole}
              onClick={() => {
                setDeletePopup(true);
                setIndex(cellInfo.rowIndex);
                setSelectRow(cellInfo.data);
              }}
            >
              <SVGComponent iconName='Icon-delete' />
            </Button>
          </OverlayTrigger>
        </div>
      );
    },
    StartDate: (cellInfo) => {
      return (
        <RenderEditableBankruptcy
          {...cellInfo}
          isEnablebyRole={isEnablebyRole}
        />
      );
    },
    EndDate: (cellInfo) => {
      return (
        <RenderEditableBankruptcy
          {...cellInfo}
          isEnablebyRole={isEnablebyRole}
        />
      );
    },
  };
  const dispatch = useDispatch();
  const bankruptcyRowData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.bankruptcyList;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const {
    data,
    cellHead,
    setGridApi,
    setColumnApi,
    permanentDeleteLaBankruptcyList,
    setPermanentDeleteLaBankruptcyList,
    setSuccessMessage,
    errorMessages,
    onFilterChanged,
    setTotalResultCount,
    setErrorMessages,
    handleOnSubmit,
    disabledSaveCancelBtn,
    resetData,
    totalResultCount,
    addEditReduxDataManufacturerTab,
    addEditManufacturerTabData,
    setDisabledSaveCancelBtn,
    fullScreenView,
    commonDropdownList,
  } = props;

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const containerStyle = useMemo(() => ({ width: '100%', height: '80%' }), []);
  const [rowData, setRowData] = React.useState([]);
  const [columnDefs, setColumnDefs] = React.useState(cellHead(kcRoles));
  const [index, setIndex] = React.useState(null);
  const [selectRow, setSelectRow] = React.useState({});
  const [deletePopup, setDeletePopup] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [gridParams, setGridParams] = React.useState(null);

  // export pdf set data on PDF format
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setGridParams(params);
  }, []);
  React.useEffect(() => {
    setRowData(data);
  }, [data]);
  const errorMessagesArray = [...errorMessages];
  // click on delete button after call
  const deleteSelectRowData = (index, data) => {
    setSuccessMessage([]);
    setDisabledSaveCancelBtn(false);
    const temp =
      bankruptcyRowData &&
      bankruptcyRowData.length > 0 &&
      bankruptcyRowData.map((item, key) => {
        if (key === index) {
          item.bankruptcyTypeCdErr = false;
          item.startDateErr = false;
          item.endDateErr = false;
        }
        return item;
      });
    dispatch(addNewRowBankruptcy(temp, 'verify'));
    setSelectRow(null);
    setIndex(null);
    const result = new Promise(() => {
      dispatch(deleteBankruptcyData(index, data));
      handleOnblurEvent();
    });
    if (permanentDeleteLaBankruptcyList && data.permanentDelete) {
      const newObj = [...permanentDeleteLaBankruptcyList];
      newObj.push(data);
      setPermanentDeleteLaBankruptcyList(newObj);
    }
  };
  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments) {
      const tempObj =
        bankruptcyRowData &&
        bankruptcyRowData?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      dispatch(addNewRowBankruptcy(tempObj, 'verify'));
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
    }
  }, [commentsList]);
  // check validation on blur event
  const handleOnblurEvent = () => {
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
    handleOnblurSelectEvent();
    handleOnblurEndDateEvent();
    if (
      bankruptcyRowData &&
      bankruptcyRowData.length > 0 &&
      bankruptcyRowData.filter((x) => {
        return x.startDateErr;
      }).length > 0
    ) {
      bankruptcyRowData.map((row) => {
        if (row.startDate === '') {
          return (
            errorMessagesArray.push(constantMessageData.START_DATE_REQUIRED),
            setErrorMessages([...new Set(errorMessagesArray)]),
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              errorMessages: [...new Set(errorMessagesArray)],
            })
          );
        }

        if (
          row.startDate !== null &&
          row.startDate !== '' &&
          validDate(new Date(row.startDate)) === false
        ) {
          return (
            errorMessagesArray.push(
              constantMessageData.DATE_INVALID_FORMAT_ERROR
            ),
            setErrorMessages([...new Set(errorMessagesArray)]),
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              errorMessages: [...new Set(errorMessagesArray)],
            })
          );
        }
        if (
          row.startDate !== null &&
          row.startDate !== '' &&
          compareTwoDatesGreaterThanOrEqual(
            new Date(row.startDate),
            moment(MinDate)
          )
        ) {
          return (
            errorMessagesArray &&
              errorMessagesArray.length > 0 &&
              errorMessagesArray.map((item, key) => {
                if (
                  item === constantMessageData.DATE_INVALID_FORMAT_ERROR ||
                  item === constantMessageData.START_DATE_REQUIRED ||
                  item.includes(
                    constantMessageData.MFG_BANKRUPTCY_OVERLAPPING_ERROR
                  )
                ) {
                  return (
                    errorMessagesArray.splice(key, 1),
                    setErrorMessages([...new Set(errorMessagesArray)]),
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      errorMessages: [...new Set(errorMessagesArray)],
                    })
                  );
                }
              }),
            errorMessagesArray.push(constantMessageData.MFG_START_DATE_ERROR),
            setErrorMessages([...new Set(errorMessagesArray)]),
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              errorMessages: [...new Set(errorMessagesArray)],
            })
          );
        }
      });
    } else if (
      (bankruptcyRowData &&
        bankruptcyRowData.length > 0 &&
        bankruptcyRowData.filter((x) => {
          return x.endDateErr;
        }).length > 0) === false
    ) {
      errorMessagesArray &&
        errorMessagesArray.length > 0 &&
        errorMessagesArray.map((item, key) => {
          if (
            item.includes('Start Date is required') ||
            item === constantMessageData.DATE_INVALID_FORMAT_ERROR ||
            item === constantMessageData.MFG_START_DATE_ERROR ||
            item.includes(constantMessageData.MFG_BANKRUPTCY_OVERLAPPING_ERROR)
          ) {
            return (
              errorMessagesArray.splice(key, 1),
              setErrorMessages([...new Set(errorMessagesArray)]),
              addEditReduxDataManufacturerTab({
                ...addEditManufacturerTabData,
                errorMessages: [...new Set(errorMessagesArray)],
              })
            );
          }
        });
    }
  };
  // check validation on blur event
  const handleOnblurEndDateEvent = () => {
    if (
      bankruptcyRowData &&
      bankruptcyRowData.length > 0 &&
      bankruptcyRowData.filter((x) => {
        return x.endDateErr;
      }).length > 0
    ) {
      bankruptcyRowData.map((row) => {
        if (
          row.endDate !== null &&
          row.endDate !== '' &&
          validDate(new Date(row.endDate)) === false
        ) {
          return (
            errorMessagesArray.push(
              constantMessageData.DATE_INVALID_FORMAT_ERROR
            ),
            setErrorMessages([...new Set(errorMessagesArray)]),
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              errorMessages: [...new Set(errorMessagesArray)],
            })
          );
        }
        if (
          row.endDate !== null &&
          row.endDate !== '' &&
          compareTwoDatesGreaterThanOrEqual(
            new Date(row.endDate),
            moment(new Date(row.startDate)).add('days', 1)
          )
        ) {
          return (
            errorMessagesArray.push(
              constantMessageData.MFG_BANKRUPTCY_END_DATE_ERROR
            ),
            setErrorMessages([...new Set(errorMessagesArray)]),
            addEditReduxDataManufacturerTab({
              ...addEditManufacturerTabData,
              errorMessages: [...new Set(errorMessagesArray)],
            }),
            errorMessagesArray &&
              errorMessagesArray.length > 0 &&
              errorMessagesArray.map((item, key) => {
                if (item === constantMessageData.DATE_INVALID_FORMAT_ERROR) {
                  return (
                    errorMessagesArray.splice(key, 1),
                    setErrorMessages([...new Set(errorMessagesArray)]),
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      errorMessages: [...new Set(errorMessagesArray)],
                    })
                  );
                }
              })
          );
        }
      });
    } else if (
      (bankruptcyRowData &&
        bankruptcyRowData.length > 0 &&
        bankruptcyRowData.filter((x) => {
          return x.startDateErr;
        }).length > 0) === false
    ) {
      errorMessagesArray &&
        errorMessagesArray.length > 0 &&
        errorMessagesArray.map((item, key) => {
          if (
            item.includes(
              'equal to the Start Date for Manufacturer Bankruptcy.'
            ) ||
            item === constantMessageData.DATE_INVALID_FORMAT_ERROR ||
            item.includes(constantMessageData.MFG_BANKRUPTCY_OVERLAPPING_ERROR)
          ) {
            return (
              errorMessagesArray.splice(key, 1),
              setErrorMessages([...new Set(errorMessagesArray)]),
              addEditReduxDataManufacturerTab({
                ...addEditManufacturerTabData,
                errorMessages: [...new Set(errorMessagesArray)],
              })
            );
          }
        });
    }
  };
  // check validation on blur event
  const handleOnblurSelectEvent = () => {
    if (
      bankruptcyRowData &&
      bankruptcyRowData.length > 0 &&
      bankruptcyRowData.filter((x) => {
        return x.bankruptcyTypeCdErr;
      }).length > 0
    ) {
      errorMessagesArray.push(constantMessageData.MFG_BANKRUPTCY_TYPE_REQUIRED);
      setErrorMessages([...new Set(errorMessagesArray)]);
      addEditReduxDataManufacturerTab({
        ...addEditManufacturerTabData,
        errorMessages: [...new Set(errorMessagesArray)],
      });
    } else {
      errorMessagesArray &&
        errorMessagesArray.length > 0 &&
        errorMessagesArray.map((item, key) => {
          if (item === constantMessageData.MFG_BANKRUPTCY_TYPE_REQUIRED) {
            return (
              errorMessagesArray.splice(key, 1),
              setErrorMessages([...new Set(errorMessagesArray)]),
              addEditReduxDataManufacturerTab({
                ...addEditManufacturerTabData,
                errorMessages: [...new Set(errorMessagesArray)],
              })
            );
          }
        });
    }
  };
  return (
    <>
      <SaveCancelPopup
        data-testid='handleDelete'
        open={deletePopup}
        title='Delete'
        moduleName='the selected record'
        onConfim={() => {
          setDeletePopup(false);
          deleteSelectRowData(index, selectRow);
        }}
        onCancel={() => {
          setDeletePopup(false);
        }}
      />

      <div data-testid='mfg-bankruptcy'>
        <div className='float-right  hide-on-print' />
        <div style={containerStyle}>
          <div className='clearfix' />
          <div className='panel-body FRR-custom-table frr-bankruptcy-select tbl-manufacturer-inner bankruptcy-cell'>
            <TableGrid
              onGridReady={onGridReady}
              ref={props.childRef}
              gridHeight={fullScreenView ? '70vh' : 400}
              rowData={
                rowData && rowData.length > 0
                  ? rowData.map((prop) => {
                      if (
                        prop?.startDate &&
                        prop.startDate?.toString()?.includes('/')
                      ) {
                        prop.startDate =
                          prop.startDate?.toString()?.length > 10
                            ? prop.startDate?.substring(0, 10)
                            : prop.startDate;
                      } else if (prop.startDate) {
                        prop.startDate = moment(prop.startDate).format(
                          'MM/DD/yyyy'
                        );
                      }
                      if (
                        prop?.endDate &&
                        prop.endDate?.toString()?.includes('/')
                      ) {
                        prop.endDate =
                          prop.endDate?.toString()?.length > 10
                            ? prop.endDate?.substring(0, 10)
                            : prop.endDate;
                      } else if (prop.endDate) {
                        prop.endDate = moment(prop.endDate).format(
                          'MM/DD/yyyy'
                        );
                      }
                      const firstDropdownVal =
                        commonDropdownList?.BANKRUPTCY_TYPE_CD?.filter((x) => {
                          return (
                            x.codeValueID &&
                            x.codeValueID?.codeValue === prop.bankruptcyTypeCd
                          );
                        });
                      if (firstDropdownVal && firstDropdownVal.length > 0) {
                        prop.bankruptcyTypeCdValWithLabel = `${
                          firstDropdownVal[0].codeValueID &&
                          firstDropdownVal[0].codeValueID.codeValue
                        } - ${firstDropdownVal[0].shortDescription}`;
                      } else {
                        prop.bankruptcyTypeCdValWithLabel = null;
                      }
                      if (prop.endDate === 'Invalid Date') {
                        prop.endDate = null;
                      }
                      if (prop.inclInvoiceInd === false) {
                        prop.inclInvoiceInd = 0;
                      }
                      return prop;
                    })
                  : []
              }
              columnDefs={columnDefs}
              frameworkComponents={frameworkComponents}
              onFilterChanged={onFilterChanged}
              onCellValueChanged={() => {
                handleOnblurEvent();
              }}
              setTotal={setTotalResultCount}
              data-testid='onEditingStopped'
              fileName='Manufacturer-Bankruptcy'
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              onSelectionChanged={(e) => {
                const selectRow = e.api.getSelectedRows()[0];
                const rowData = selectRow.mfgBankCruptcyId;
                props.setBankruptcyTypeCd(selectRow.bankruptcyTypeCd);
                props.setStartDt(
                  rowData && rowData.startDate
                    ? rowData && rowData.startDate
                    : null
                );
              }}
            />
          </div>
        </div>
      </div>
      <div className='tab-header tab-total-results'>
        <p className='total-results' tabIndex='0'>
          Total Results:<b>{totalResultCount?.toLocaleString('en-US')}</b>
        </p>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName='MFG_BANKRUPTCY'
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={props.values && props.values.mfgId}
        />
      ) : null}
    </>
  );
}
